import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { AppLayout } from 'containers';
import Subheader from 'material-ui/Subheader';
import { ReactHeight, getElementHeight } from 'react-height';
import { initOrg, toggleAllSelected, loadConversations, setSelectedConversation, setSelectedViewType, setConversationChecked, createComment, reactToComment, archiveConversations, unarchiveConversations } from 'redux/modules/messageCenter2';
import { ControlBar, Control, GrayButton, PageHeader, Snackbar, Spinner, EmptyState } from 'components';
import { FilterPanel } from 'components/MessageCenter';
import { connect } from 'react-redux';
import * as styles from './MessageCenter.scss';
import ConversationList from './ConversationList';
import Conversation from './Conversation';
import PostPreview from './PostPreview';
import throttle from 'lodash.throttle';
import io from 'socket.io-client';
import * as listStyles from './ConversationList.scss';
import { goToAnchor } from 'react-scrollable-anchor';
var MessageCenter = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    organization: state.organization.current,
    theme: state.theme,
    archivedConversations: state.messageCenter.archivedConversations ? state.messageCenter.archivedConversations : [],
    pagination: state.messageCenter.conversations ? state.messageCenter.pagination : {},
    conversationThreads: state.messageCenter && state.messageCenter.threadsById ? state.messageCenter.threadsById : {},
    filters: state.messageCenter && state.messageCenter.filters ? state.messageCenter.filters : null,
    selectedIndex: state.messageCenter.selectedConversationIndex,
    viewType: state.messageCenter ? state.messageCenter.selectedViewType : 0,
    config: state.config,

    /** **/
    messageCenter: state.messageCenter.byOrgId["".concat(orgId)],
    conversations: state.messageCenter.byOrgId["".concat(orgId)] ? state.messageCenter.byOrgId["".concat(orgId)].conversations : [],
    socialAccounts: state.organization.current.SocialAccounts
  };
}, {
  initOrg: initOrg,
  loadConversations: loadConversations,
  toggleAllSelected: toggleAllSelected,
  setSelectedConversation: setSelectedConversation,
  setSelectedViewType: setSelectedViewType,
  setConversationChecked: setConversationChecked,
  createComment: createComment,
  reactToComment: reactToComment,
  archiveConversations: archiveConversations,
  unarchiveConversations: unarchiveConversations
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(MessageCenter, _Component);

  var _super = _createSuper(MessageCenter);

  function MessageCenter(props) {
    var _this;

    _classCallCheck(this, MessageCenter);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleArchive", function () {
      var selected = Object.keys(_this.props.messageCenter.checkedConversations).map(function (k) {
        return _this.props.messageCenter.checkedConversations[k] ? k : null;
      }).filter(function (n) {
        return n;
      });

      if (_this.props.messageCenter.selectedViewType === 0) {
        _this.props.archiveConversations(_this.props.organization.id, selected);
      } else {
        _this.props.unarchiveConversations(_this.props.organization.id, selected);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleRefresh", function () {
      _this.props.loadConversations(_this.props.organization.id);
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelectAll", function () {
      _this.props.toggleAllSelected(_this.props.conversations.map(function (c) {
        return c.id;
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "handleListChange", function (selectedIndex) {
      _this.props.setSelectedConversationIndex(selectedIndex);
    });

    _defineProperty(_assertThisInitialized(_this), "replyRefMap", {});

    _defineProperty(_assertThisInitialized(_this), "registerReplyRef", function (objectId) {
      return function (ref) {
        return _this.replyRefMap["".concat(objectId)] = ref;
      };
    });

    _this.state = {
      initialArchiveLoadDone: false,
      initialLoadDone: false,
      showLoadingDelaySnackbar: false,
      showSocketUpdateSnackbar: false,
      showRefreshSnackbar: false,
      leftPanelHeight: 100,
      rightPanelHeight: 100,
      conversationPage: 1
    };
    return _this;
  }

  _createClass(MessageCenter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // window.addEventListener('resize', () => this.forceUpdate());
      if (!this.props.messageCenter) {
        this.props.initOrg(this.props.organization.id);
      }

      this.props.loadConversations(this.props.organization.id);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _ref = this.props.messageCenter ? this.props.messageCenter : {},
          allConversations = _ref.conversations,
          archivedConversations = _ref.archivedConversations,
          selectedViewType = _ref.selectedViewType,
          checkedConversations = _ref.checkedConversations,
          selectedConversationId = _ref.selectedConversationId,
          creatingComment = _ref.creatingComment,
          loadingConversations = _ref.loadingConversations,
          conversationPage = _ref.conversationPage;

      var conversations = allConversations ? _toConsumableArray(allConversations).filter(function (c) {
        return selectedViewType === 0 ? !c.archived : c.archived;
      }) : [];

      var selectedConversation = function () {
        if (conversations && conversations.length > 0) {
          if (selectedConversationId) {
            var c = conversations.find(function (c) {
              return "".concat(c.id) === "".concat(selectedConversationId);
            });

            if (c) {
              return _objectSpread({}, c);
            }
          }

          return _objectSpread({}, conversations[0]);
        }

        return null;
      }();

      return /*#__PURE__*/React.createElement(AppLayout, {
        params: _objectSpread({}, this.props.params),
        appLayoutInnerStyle: {
          display: 'flex',
          flex: '1 1 auto',
          padding: 0,
          overflow: 'auto',
          height: '100%'
        }
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Message Center"
      }), /*#__PURE__*/React.createElement("div", {
        className: styles.container
      }, /*#__PURE__*/React.createElement(PageHeader, {
        primary: "Message Center",
        style: {
          paddingLeft: 36
        }
      }), !selectedConversation && (!allConversations || allConversations.length === 0) ? /*#__PURE__*/React.createElement("div", null, !loadingConversations ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(EmptyState, {
        text: "You don't have any messages yet. Comments on your posts will appear here.",
        iconName: "fa fa-comments",
        iconSize: "95px",
        style: {
          marginTop: 24
        }
      })) : /*#__PURE__*/React.createElement(Spinner, {
        style: {
          position: 'relative'
        },
        center: true
      })) : /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("div", {
        className: styles.controlBarWrap
      }, /*#__PURE__*/React.createElement(ControlBar, null, /*#__PURE__*/React.createElement(Control, {
        type: "checkbox",
        onClick: this.handleSelectAll
      }), !!checkedConversations && Object.keys(checkedConversations).some(function (k) {
        return !!checkedConversations[k];
      }) ? /*#__PURE__*/React.createElement(Control, {
        text: selectedViewType === 0 ? 'Archive' : 'Move to Inbox',
        onClick: this.handleArchive
      }) : null)), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          width: 'calc(100% - 70px)'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          maxWidth: 550,
          minWidth: 400,
          display: 'flex',
          flex: 0.349
        }
      }, /*#__PURE__*/React.createElement(Subheader, {
        className: styles.subheader,
        style: {
          fontWeight: 300,
          color: '#717171',
          paddingLeft: 0
        }
      }, /*#__PURE__*/React.createElement(ControlBar, _defineProperty({
        style: {
          flex: '0 0 100%'
        }
      }, "style", {
        borderTop: 0
      }), /*#__PURE__*/React.createElement(Control, {
        text: "Inbox",
        className: "".concat(listStyles.tabControl, " ").concat(selectedViewType === 0 ? '' : listStyles.tabControlInactive),
        onClick: function onClick() {
          return _this2.props.setSelectedViewType(_this2.props.organization.id, 0);
        },
        innerStyle: {
          boxShadow: 'none',
          flex: 1,
          width: '100%'
        },
        style: {
          width: '100%',
          textAlign: 'center'
        }
      }), /*#__PURE__*/React.createElement(Control, {
        text: "Archived",
        className: "".concat(listStyles.tabControl, " ").concat(selectedViewType === 1 ? '' : listStyles.tabControlInactive),
        onClick: function onClick() {
          return _this2.props.setSelectedViewType(_this2.props.organization.id, 1);
        },
        innerStyle: {
          boxShadow: 'none',
          flex: 1,
          width: '100%'
        },
        style: {
          width: '100%',
          textAlign: 'center'
        }
      }))))), /*#__PURE__*/React.createElement("div", {
        className: styles.columnWrap,
        style: {
          bottom: 0,
          position: 'absolute',
          top: 289,
          width: 'calc(100% - 70px)'
        }
      }, /*#__PURE__*/React.createElement("div", {
        ref: "leftPanel",
        className: styles.leftPanel,
        style: {
          position: 'relative',
          minHeight: 200
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          overflowY: 'auto'
        }
      }, conversations && conversations.length > 0 ? /*#__PURE__*/React.createElement(ConversationList, {
        handleListChange: /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id) {
            var result, stateUpdate;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    if (!(id === 'load_more')) {
                      _context.next = 10;
                      break;
                    }

                    _context.next = 3;
                    return _this2.props.loadConversations(_this2.props.organization.id, 10, 10 * conversationPage);

                  case 3:
                    result = _context.sent;
                    console.log(result);
                    stateUpdate = {};

                    if (result.data && result.data.length === 0) {
                      stateUpdate.noMorePages = true;
                    }

                    _this2.setState(stateUpdate);

                    _context.next = 11;
                    break;

                  case 10:
                    _this2.props.setSelectedConversation(_this2.props.organization.id, id);

                  case 11:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }(),
        onConversationChecked: function onConversationChecked(conversationId, isChecked) {
          _this2.props.setConversationChecked(_this2.props.organization.id, conversationId, isChecked);
        },
        selectedConversationId: selectedConversationId,
        conversations: conversations,
        selectedConversations: checkedConversations,
        viewType: selectedViewType,
        loadingConversations: loadingConversations,
        hasMore: !this.state.noMorePages
      }) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(EmptyState, {
        text: selectedViewType === 0 ? 'Your Inbox is Empty!' : 'You do not have any Archived conversations.',
        iconName: selectedViewType === 0 ? 'fa fa-inbox' : 'fa fa-archive',
        iconSize: "95px",
        style: {
          marginTop: 24
        }
      })))), /*#__PURE__*/React.createElement("div", {
        ref: "rightPanel",
        style: {
          display: 'flex',
          flex: '2',
          flexDirection: 'column',
          minWidth: 400,
          overflow: 'auto'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexWrap: 'wrap',
          maxWidth: 580,
          alignSelf: 'center'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.middlePanel,
        style: {
          position: 'relative',
          minHeight: 200
        }
      }, selectedConversation && /*#__PURE__*/React.createElement(Conversation, {
        registerRef: this.registerReplyRef,
        creatingComment: creatingComment,
        orgSocialAccounts: this.props.socialAccounts,
        handlePostToggleLike: this.state.likeUnlikeFunc,
        conversation: selectedConversation,
        handleReaction: /*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(objectId, type) {
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.prev = 0;
                    _context2.next = 3;
                    return _this2.props.reactToComment(_this2.props.organization.id, objectId);

                  case 3:
                    _context2.next = 5;
                    return _this2.props.loadConversations(_this2.props.organization.id);

                  case 5:
                    _context2.next = 10;
                    break;

                  case 7:
                    _context2.prev = 7;
                    _context2.t0 = _context2["catch"](0);
                    console.error(_context2.t0);

                  case 10:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, null, [[0, 7]]);
          }));

          return function (_x2, _x3) {
            return _ref3.apply(this, arguments);
          };
        }(),
        handleClearReaction: /*#__PURE__*/function () {
          var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(objectId) {
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.prev = 0;
                    _context3.next = 3;
                    return _this2.props.reactToComment(_this2.props.organization.id, objectId, true);

                  case 3:
                    _context3.next = 5;
                    return _this2.props.loadConversations(_this2.props.organization.id);

                  case 5:
                    _context3.next = 10;
                    break;

                  case 7:
                    _context3.prev = 7;
                    _context3.t0 = _context3["catch"](0);
                    console.error(_context3.t0);

                  case 10:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3, null, [[0, 7]]);
          }));

          return function (_x4) {
            return _ref4.apply(this, arguments);
          };
        }(),
        handleSubmitComment: function handleSubmitComment(objectId) {
          return /*#__PURE__*/function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(message, attachmentData, gifData) {
              var reqData, files, _yield$_this2$props$c, data;

              return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      _context4.prev = 0;
                      reqData = {
                        toFacebookObjectId: objectId
                      };
                      files = [];
                      console.log('Submit comment');

                      if (!(!attachmentData && gifData)) {
                        _context4.next = 9;
                        break;
                      }

                      console.log('Should send GIF comment', gifData);
                      reqData.attachment_share_url = gifData.url;
                      _context4.next = 21;
                      break;

                    case 9:
                      if (!(attachmentData && attachmentData.file && !gifData)) {
                        _context4.next = 15;
                        break;
                      }

                      console.log("Should send attachment comment. Message: \"".concat(message, "\" | Attachment:"), attachmentData.file);

                      if (message) {
                        reqData.message = message;
                      }

                      files.push(attachmentData.file);
                      _context4.next = 21;
                      break;

                    case 15:
                      if (!(message && message.length > 0)) {
                        _context4.next = 20;
                        break;
                      }

                      console.log("Should send message-only comment. Message: \"".concat(message, "\""));
                      reqData.message = message;
                      _context4.next = 21;
                      break;

                    case 20:
                      return _context4.abrupt("return", alert('Please enter a comment.'));

                    case 21:
                      _context4.next = 23;
                      return _this2.props.createComment(_this2.props.organization.id, reqData, files);

                    case 23:
                      _yield$_this2$props$c = _context4.sent;
                      data = _yield$_this2$props$c.data;
                      _context4.next = 27;
                      return _this2.props.loadConversations(_this2.props.organization.id);

                    case 27:
                      goToAnchor("comment_".concat(data.facebookId));
                      _this2.replyRefMap["".concat(data.parentObjectId)] ? _this2.replyRefMap["".concat(data.parentObjectId)].clear() : null;
                      _context4.next = 34;
                      break;

                    case 31:
                      _context4.prev = 31;
                      _context4.t0 = _context4["catch"](0);
                      console.error(_context4.t0);

                    case 34:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, _callee4, null, [[0, 31]]);
            }));

            return function (_x5, _x6, _x7) {
              return _ref5.apply(this, arguments);
            };
          }();
        }
      }))))))));
    }
  }]);

  return MessageCenter;
}(Component)) || _class);
export default MessageCenter;